import InvoiceDetailView from './InvoiceDetailView';

export default InvoiceDetailView;
